import React from "react";

const SectionHeader = ({ title, className }) => {
  return (
    <h2 className={`text-[22px] font-semibold text-gray-800 ${className || ""}`}>{title}</h2>
  );
};

export default SectionHeader;
